import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';
import * as React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Text, TextButton } from '@wix/design-system';
import { PageFooter } from 'components/PageFooter/PageFooter';
import { RootStore, withInjectedRootStore } from 'providers';
import s from './PlansPageFooter.scss';
import { Experiments } from 'enums';

const PlansPageFooterComp: React.FC<
  {
    rootStore: RootStore;
  } & InjectedExperimentsProps
> = ({ rootStore }) => {
  const { isEditorXSpecialDiscountEnabled, isDayful, experiments } = rootStore.appStore;
  const getFooterKey = () => {
    const { pricesIncludeTax } = rootStore.appStore;

    return pricesIncludeTax
      ? 'page_footer.plans_disclaimer_no_vat'
      : 'page_footer.plans_disclaimer_applicable_tax';
  };
  const { t } = useTranslation();

  const isAiFeaturesEnabled =
    experiments[Experiments.EnableAiFeatures] === 'true';

  const translationTags = {
    b: <b />,
    voucher: (
      <span
        data-hook='voucher-disclaimer'
        className={
          rootStore.appStore.isVoucherDisclaimerHidden
            ? s.hiddenLabel
            : s.visibleLabel
        }
      />
    ),
  };
  return (
    <PageFooter>
      {isEditorXSpecialDiscountEnabled && (
        <div>
          <Text
            weight='thin'
            size='tiny'
            dataHook='special-discount-disclaimer'
            secondary
          >
            {t('special_discount_disclaimer')}
          </Text>
        </div>
      )}
      <Text
        className={s.disclaimersText}
        weight='thin'
        size='tiny'
        dataHook='disclamer'
        secondary
      >
        {
          experiments[Experiments.EnableImmediateCouponsDeliverySpec] === 'true'
            ?
            <>
              {' '}
              <Trans
                i18nKey={'premium-purchase-plan.disclaimer.voucher.new_sale'}
                components={translationTags} />
              {' '}
            </> :
            null
        }
        <Trans i18nKey={getFooterKey()} components={translationTags} />
        {
          experiments[Experiments.EnableImmediateCouponsDeliverySpec] === 'true'
            ?
            <>
              {' '}
              <Trans
                i18nKey={'premium-purchase-plan.disclaimer.business_email_email_marketing.new_sale'}
                components={{
                  ...translationTags,
                  Link: <a
                    href="https://support.wix.com/en/article/about-your-free-domain-voucher"
                    target={'_blank'} />
                }} />
            </> :
            null
        }
        {isDayful && (
          <>
            <br />
            <Trans i18nKey='page_footer.dayful.disclaimer_fees' />
            <br />
            <Trans i18nKey='page_footer.dayful.disclaimer_inapp_purchases' />
          </>
        )}
        {isAiFeaturesEnabled && (
          <>
            <br />
            <br />
            <Trans i18nKey='premium-purchase-plan.package_picker.disclaimer.ai_features' />
            <Trans
              i18nKey='premium-purchase-plan.package_picker.disclaimer.ai_usage'
              components={{
                1: (
                  <TextButton
                    size='tiny'
                    weight='thin'
                    as='a'
                    href='https://support.wix.com/en/article/about-ai-credits'
                    target='_blank'
                  />
                ),
              }}
            />
          </>
        )}
      </Text>
    </PageFooter>
  );
};

export const PlansPageFooter = withExperiments(
  withInjectedRootStore(PlansPageFooterComp),
);
